import React from "react";
import { useTranslation } from "react-i18next";
import { CONTENT_WIDTH } from "../../utils/layout";
import { isRtlLanguage } from "../../utils/i18n";
import ScrollReveal from "./Reveal";

function ImageTextRow({
  image,
  titleMode = "plain",
  titlePrefix,
  titleHighlight,
  titleEn,
  titleAr,
  descriptionKey,
  reverse = false,
}) {
  const { t, i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);
  const rowDirection = reverse ? "md:flex-row-reverse" : "md:flex-row";

  const renderTitle = () => {
    if (titleMode === "split") {
      if (isRtl) {
        return <h3 className="caf-row-title">{titleAr}</h3>;
      }
      return (
        <h3 className="caf-row-title">
          {titlePrefix} <span>{titleHighlight}</span>
        </h3>
      );
    }

    if (isRtl) {
      return <h3 className="caf-row-title">{titleAr}</h3>;
    }
    return <h3 className="caf-row-title">{titleEn}</h3>;
  };

  return (
    <ScrollReveal
      className={`${CONTENT_WIDTH} caf-content-row flex flex-col gap-6 ${rowDirection} md:items-center md:justify-between`}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div className="flex w-full justify-center md:w-[35%]">
        <div className="caf-media-frame w-full max-w-[240px] sm:max-w-[280px] md:max-w-[300px]">
          <img src={image} alt="" loading="lazy" />
        </div>
      </div>
      <div className="flex w-full flex-col gap-3 md:w-[58%]">
        <div
          className="caf-title-accent caf-title-accent--start"
          aria-hidden="true"
        />
        {renderTitle()}
        <p className="caf-row-body text-start">{t(descriptionKey)}</p>
      </div>
    </ScrollReveal>
  );
}

export default ImageTextRow;
